<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>物料管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a>申请记录</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section>
      <section class="searchBox">
        <span>
          <label>日期：</label>
          <a-range-picker
            v-model="dateDefault"
            @change="selectedDate"
            style="width:200px"
          />
        </span>
        <span>
          <label>类型：</label>
          <a-radio-group v-model="status">
            <a-radio :value="1">待审核</a-radio>
            <a-radio :value="2">已驳回</a-radio>
            <a-radio :value="3">已发放</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <div>
            <a-input
              placeholder="请输入物料名称 | 员工名称"
              v-model="query_field"
              style="margin-right:20px;"
            />
          </div>
        </span>
        <span>
          <a-button @click="reactPage" style="margin-right:10px;"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.create_time.substring(0, 10) }}</td>
              <td>
                <p v-if="item.status == 1">待审核</p>
                <p v-else-if="item.status == 2">已驳回</p>
                <p v-else-if="item.status == 3">已发放</p>
              </td>
              <td>{{ item.guard_user_name }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.total_in + item.unit }}</td>
              <td>{{ item.order_consume + item.unit }}</td>
              <td>{{ item.guard_surplus + item.unit }}</td>
              <td>{{ item.number + item.unit }}</td>
              <td>{{ item.real_number + item.unit }}</td>
              <td>
                <a
                  v-show="item.status == 1"
                  style="color:#409EFF"
                  @click="auditPage(item)"
                  >待审核</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 审核 -->
    <aside class="dialogsBox" v-show="auditIsShow">
      <div>
        <h3>审核</h3>
        <a @click="auditIsShow = false" class="close">
          <a-icon type="close-circle" style="fontSize:30px;color:#333" />
        </a>
        <ul v-if="auditDetail">
          <li>
            <label>申请员工：</label>
            <p>{{ auditDetail.name }}</p>
          </li>
          <li>
            <label>物料名称：</label>
            <p>{{ auditDetail.guard_user_name }}</p>
          </li>
          <li>
            <label>申请数量：</label>
            <p>{{ auditDetail.number + auditDetail.unit }}</p>
          </li>
          <li>
            <label>实发数量：</label>
            <a-input-number v-model="realNumber" />
            <span>{{ "&nbsp;" + auditDetail.unit }}</span>
          </li>
        </ul>
        <div>
          <a-button type="danger" @click="auditReject">驳回</a-button>
          <a-button type="primary" @click="auditPass">同意</a-button>
        </div>
      </div>
    </aside>
    <!-- 审核 end -->
    <!-- 驳回 -->
    <aside class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width:300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectCancel">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </aside>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      query_field: "",
      typeSearch: -1,
      totalPage: Number,
      thList: [
        "申请日期",
        "状态",
        "员工姓名",
        "物料名称",
        "总发放数",
        "预计消耗",
        "预计剩余",
        "申请数量",
        "实际发放",
        "操作"
      ],
      auditIsShow: false,
      auditDetail: {},
      realNumber: "",
      dateDefault: null,
      status: "",
      reason: "",
      rejectIsShow: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    rejectCancel() {
      this.reason = "";
      this.rejectIsShow = false;
    },
    selectedDate(data, dataString) {
      this.start_date = dataString[0];
      this.end_date = dataString[1];
    },
    auditReject() {
      this.auditIsShow = false;
      this.rejectIsShow = true;
    },
    rejectSure() {
      if (this.reason != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.clean +
          "Material/rejectMaterial";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          reason: this.reason,
          apply_material_id: this.auditDetail.id
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("申请已驳回");
            this.reason = "";
            this.rejectIsShow = false;
            this.reload();
          } else {
            this.rejectIsShow = false;
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请输入驳回原因！");
      }
    },
    auditPass() {
      this.auditIsShow = false;
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "请确定实际发放金额后点击确定",
        onOk() {
          _this.auditPassHttp();
        }
      });
    },
    auditPassHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Material/outApplyMaterial";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        real_number: this.realNumber,
        apply_material_id: this.auditDetail.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("物料已发放");
          this.realNumber = "";
          this.reload();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    auditPage(val) {
      this.auditDetail = val;
      this.realNumber = this.auditDetail.number;
      this.auditIsShow = true;
    },
    reactPage() {
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.status = "";
      this.dateDefault = undefined;
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Material/applyMaterialList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          status: this.status,
          start_date: this.start_date,
          end_date: this.end_date,
          query_field: this.query_field,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.areaStyle {
  p {
    display: inline-block;
  }
}
.listContainer {
  .searchBox {
    display: block;
    .addStyle {
      margin-right: 24%;
    }
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 10px;
      > div {
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
